import React from 'react';
import { AdminEmpty } from '../adminUi';
import { GradingProvider, useGrading } from './GradingContext';
import GradingCalibrationTab from './GradingCalibrationTab';
import GradingDrawer from './GradingDrawer';
import GradingFactorsTab from './GradingFactorsTab';
import GradingPreviewTab from './GradingPreviewTab';
import GradingQuestionsTab from './GradingQuestionsTab';
import GradingRolesTab from './GradingRolesTab';
import { GradingTabs } from './GradingShared';
import GradingTreeTab from './GradingTreeTab';

function GradingContent() {
  const { tab, setTab, loading, error, reload } = useGrading();

  if (loading) return <AdminEmpty>Загрузка дерева грейдинга…</AdminEmpty>;
  if (error) {
    return (
      <AdminEmpty>
        <p className="mb-3 text-red-600">{error}</p>
        <button type="button" className="dc-btn-secondary" onClick={() => reload()}>Повторить</button>
      </AdminEmpty>
    );
  }

  return (
    <div className="dc-grading-section">
      <GradingTabs tab={tab} onTab={setTab} />
      <div className="dc-grading-tab-panel">
        {tab === 'tree' && <GradingTreeTab />}
        {tab === 'calibration' && <GradingCalibrationTab />}
        {tab === 'factors' && <GradingFactorsTab />}
        {tab === 'questions' && <GradingQuestionsTab />}
        {tab === 'roles' && <GradingRolesTab />}
        {tab === 'preview' && <GradingPreviewTab />}
      </div>
      <GradingDrawer />
    </div>
  );
}

export default function GradingSection() {
  return (
    <GradingProvider>
      <GradingContent />
    </GradingProvider>
  );
}
